import React from "react";
import { BotNAcciN } from "../../components/BotNAcciN";
import { InputContraseA } from "../../components/InputContraseA";
import { StateDefaultWrapper } from "../../components/StateDefaultWrapper";
import "./style.css";
import { CognitoUser, CognitoUserPool, AuthenticationDetails } from 'amazon-cognito-identity-js';
import AWS from 'aws-sdk';
import { useState } from 'react';
import { resetPassword } from 'aws-amplify/auth';
import { confirmResetPassword } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import config from '../../amplifyconfiguration.json';
import awsconfig from '../../aws-exports';
import {signOut, getCurrentUser, confirmSignIn, signIn} from 'aws-amplify/auth';





export const LoginClear = ({updateState}) => {
  AWS.config.region = 'us-east-1';
  //Amplify.configure(config);
  Amplify.configure(awsconfig);

  const [username, setUser] = useState('');
  const [loading, setLoading] = useState(false);

  const handleUserInputChange = (username) => {
    setUser(username);
  };

  const [password, setPassword] = useState('');

  const handlePasswordInputChange = (password) => {
    setPassword(password);
  };


  const handleSignIn = async (username, password) => {
                      try{

                          const {

                            username,

                            signInDetails

                          } = await getCurrentUser();
                          await signOut();
                      } catch (error) { 

                      }
                      const {

                        isSignedIn,

                        nextStep

                      } = await signIn({ username, password });

                      switch (nextStep.signInStep) {

                        case 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED':

                          
                          //const newPassword = 'nueva password';
                          
                          const newPassword = '';
                          const {

                            isSignedIn,

                            nextStep

                          } = await confirmSignIn({

                            challengeResponse: newPassword

                          });
                          console.log("New Password Required")

                          break;

                        case 'DONE':

                          console.log("Login existoso!!!")
                          updateState();

                      }

                      

            }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await handleSignIn(username, password);
    //setLoading(false);

    /*
    const authenticationData = {
      Username: username,
      Password: password,
    };

    const authenticationDetails = new AuthenticationDetails(authenticationData);

    const userData = {
      Username: username,
      Pool: new CognitoUserPool({
        UserPoolId: 'us-east-1_JlIagsZwV',
        ClientId: '716427gjq9dbjr1hnbn0bkhkf1',
      }),
    };
  
    const cognitoUser = new CognitoUser(userData);

     cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (session) => {
        console.log('Inicio de sesión exitoso:', session);
        // Aquí puedes redirigir o realizar acciones adicionales después del inicio de sesión exitoso.
      },
      onFailure: (err) => {
        console.error('Error en el inicio de sesión:', err);
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        // En caso de que se requiera un cambio de contraseña
        const newPassword = '4LrS*&Rb';
        console.log('Cambio de contraseña requerido');
        console.log('userAttributes:', userAttributes);
        cognitoUser.completeNewPassword(newPassword, {}, {
          onSuccess: (session) => {
            console.log('Inicio de sesión exitoso después de cambiar la contraseña:', session);
            // Realiza acciones adicionales después del inicio de sesión exitoso, si es necesario
          },
          onFailure: (err) => {
            console.error('Error en el inicio de sesión después de cambiar la contraseña:', err);
          }
        });
        completeNewPassword({
                            user,
                            password: password,
                            newPassword: newPassword
                        });
        async function completarDesafioNuevaContrasena(username, newPassword) {
          try {
            const user = await Auth.signIn(username); // Iniciar sesión para obtener el objeto de usuario
            const result = await Auth.completeNewPassword(user, newPassword, {});
            
            console.log('Resultado de completar desafío de nueva contraseña:', result);
          } catch (error) {
            console.error('Error al completar desafío de nueva contraseña:', error);
          }
        }
        
        completarDesafioNuevaContrasena(username, newPassword);

      },
    });*/

  };
   
  return (
    
    <div className="login-clear">
    {loading ? (
        <div className="loading-div">
          <img className="loading" src="/img/loading.gif" alt="Cargando..." />
        </div >
        ) : null}
      <div className="logo-container">
        <img className="background" alt="Background" src="/img/background.png" />
        {/*<img className="holding-viewer-logo" alt="holding-viewer-logo" src="/img/holding-viewer-logo.png" />*/}
        <div className="segmentatio-logo">
          <div className="group">
            <div className="isolation-mode">
              <div className="group">
                <div className="overlap">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group">
                      <div className="group-2" />
                      </div>
                    </div>
                    <div className="overlap-wrapper">
                      <div className="overlap-2">
                        <div className="group-3" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div className="bloque-inicio-sesin">
          <div className="text-wrapper">Iniciar sesión</div>
          <div className="info-input">
            <InputContraseA
              onInputChange = {handleUserInputChange} 
              className="input-contrasea"
              iconPerson="/img/icon-person-2.png"
              stateProp="default"
              text="Usuario"
            />
            <StateDefaultWrapper
              onInputChange = {handlePasswordInputChange}
              className="input-contrasea"
              iconPerson="/img/icon-person-1.png"
              stateProp="default"
              text="Contraseña"
            />
          </div>
          <BotNAcciN className="botn-accin" text="Ingresar" onClick={handleSubmit}/>
      </div>
    </div>
  );
};
